import { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../../CartContext";
import Header from "../Header&Footer/Header";
import classes from "./success.module.css";

const SuccessPage = () => {
  const cart = useContext(CartContext);
  cart.getTotalCost();
  // const id
  return (
    <Fragment>
      <Header />
      <section className={classes.success}>
        <h1>
          Your Order of N{cart.getTotalCost()} Has Been Successfully Received!
        </h1>
        <div className={classes.check}>
          <span class="material-symbols-outlined">done</span>
        </div>
        <h3>Delivery Status: Processing</h3>
        <h2>
          Chat Us On
          <a href="https://api.whatsapp.com/send?phone=23408144278102&text=Hi%20DC%20Luxury,%20I%20just%20Paid%20for%20an%20order,%20My%20name%20is%20%20is%20">
            Whatsapp
          </a>
        </h2>
        <Link to="/">Back to home...</Link>
      </section>
    </Fragment>
  );
};

export default SuccessPage;
